import http from '../httpService';

export const getAllServiceProviders = (page) => {
  return http.get(`/service-providers?page=${page}`);
};

export function deleteServiceProviders(id) {
  return http.delete(`/service-providers/${id}`);
}
export function updateServiceProviders(id,payload) {
  return http.put(`/service-providers/${id}`, payload);
}

export function createServiceProviders(formData) {
  return http.post('/service-providers', formData);
}